var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass(),style:(this.small ? 'padding: 12px 12px;' : 'padding: 18px 10px;'),on:{"click":this.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }